// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInCalendarQuarters as fn } from "../differenceInCalendarQuarters.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInCalendarQuartersWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInCalendarQuartersWithOptions;
